/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum OpportunityContactRole {
  DecisionMaker = "DecisionMaker",
  Buyer = "Buyer",
  ExecutiveSponsor = "ExecutiveSponsor",
  Influencer = "Influencer",
  Coach = "Coach",
  BusinessUser = "BusinessUser",
  AddedByClient = "AddedByClient",
  None = "None",
}

export const OpportunityContactRoleDisplay: Record<OpportunityContactRole, string> = {
  [OpportunityContactRole.DecisionMaker]: "Decision Maker",
  [OpportunityContactRole.Buyer]: "Buyer",
  [OpportunityContactRole.ExecutiveSponsor]: "Executive Sponsor",
  [OpportunityContactRole.Influencer]: "Influencer",
  [OpportunityContactRole.Coach]: "Coach",
  [OpportunityContactRole.BusinessUser]: "Business User",
  [OpportunityContactRole.AddedByClient]: "Added By Client",
  [OpportunityContactRole.None]: "None",
};
